import vhis from "./vhis.js"

export default vhis
